import React, { useEffect, useState } from "react";
import {
  deleteCategoriesServer,
  getCategoriesServer,
} from "../../../apis/categoriesApi";
import { Table } from "antd";
import getCategoriesColumns from "../../../const/Columns/getCategoryColumns";
import { Link } from "react-router-dom";

const Category = () => {
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredCategories, setFilteredCategories] = useState([]);

  useEffect(() => {
    if (category?.length > 0) {
      const filtered = category?.filter((catg) =>
        catg.name?.toLowerCase().includes(searchText.toLowerCase()),
      );
      setFilteredCategories(filtered);
    }
  }, [searchText, category]);

  useEffect(() => {
    fetchCategory();
  }, []);

  const fetchCategory = async () => {
    try {
      const res = await getCategoriesServer();
      setCategory(res.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const deleteCategory = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Category?",
    );
    if (isConfirmed) {
      await deleteCategoriesServer(id);
      setLoading(true);
      fetchCategory();
    }
  };

  const columns = getCategoriesColumns(deleteCategory);
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              <Link to="/addCategory" className="btn add-new btn-primary mb-3">
                Add Category
              </Link>
              {/* Search Input */}
              <input
                type="text"
                placeholder="Search by title"
                className="form-control w-25"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={
                    searchText && filteredCategories?.length > 0
                      ? filteredCategories
                      : category?.length > 0
                        ? category
                        : []
                  }
                  className="table-striped "
                  rowKey={(record) => record.id}
                  // scroll={{ y: 400 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Category;
